import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Carousel from '../../global/components/carousel/Carousel';
import ItemCard from './ItemCard';
import { fade } from '../../utils/transitionIndex';
import './QuestGalleryItem.scss';

const Activator = ({ handleOpen, isImage, isMobile, img }) => {
  if (!isImage) return null;

  return (
    <div
      onClick={isMobile ? () => null : handleOpen}
      className="galleryItem"
    >
      {isMobile ? (
        <a href={img} target="_blank" rel="noreferrer">
          <img className="galleryImage" src={img} alt="gallery item" />
        </a>
      ) : (
        <img src={img} className="galleryImage" alt="gallery item" />
      )}
      <span className="cornerBtn" />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: '900px',
    maxHeight: '90vh',
    borderRadius: '8px',
    padding: theme.spacing(2, 2, 2),
    outline: 'none',
    // 📱 移动端优化
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: theme.spacing(1, 2, 2),
    },
  },
}));

const GalleryModal = ({ img = '', isMobile = false, items = [], isImage = true }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const itemCards = items.map((item, idx) => (
    <ItemCard baseCSS item={{ image: item }} key={idx} />
  ));

  const body = (
    <div className={classes.paper}>
      <Carousel
        showLearnMore={false}
        items={itemCards}
        width="100%"
        centerMode={false}
        showArrows
        baseCSS
      />
    </div>
  );

  return (
    <div className="gallery-modal-wrapper">
      {!isImage && (
        <button onClick={handleOpen} className="button">
          View All
        </button>
      )}

      <Activator
        isImage={isImage}
        isMobile={isMobile}
        handleOpen={handleOpen}
        img={img}
      />

      {open && (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="gallery-modal-title"
          aria-describedby="gallery-modal-description"
        >
          <TransitionGroup component={null}>
            <CSSTransition {...fade()} key={open}>
              {body}
            </CSSTransition>
          </TransitionGroup>
        </Modal>
      )}
    </div>
  );
};

export default GalleryModal;
